


























































import { defineComponent, SetupContext } from '@vue/composition-api';
interface Props {
  options: string[][];
  allowReset: boolean;
}

const Component = defineComponent({
  name: 'SizeChart',

  props: {
    options: Array,
    allowReset: Boolean,
  },

  setup(props: Props, { emit }: SetupContext) {
    function deleteColumn(colNumber: number) {
      const arr = props.options;
      arr.forEach(i => i.splice(colNumber, 1));
      emit('value-update', arr);
    }
    function deleteRow(rowNumber: number) {
      const arr = props.options;
      arr.splice(rowNumber, 1);
      emit('value-update', arr);
    }
    function addColumn() {
      const arr = props.options;
      arr.forEach(i => i.push(''));
      emit('value-update', arr);
    }
    function addRow() {
      if (props.options.length > 0) {
        const arr = props.options;
        arr.push(arr[0].map(i => ''));
        emit('value-update', arr);
      } else emit('value-update');
    }

    function updateValue(e: any, rnum: number, cnum: number) {
      emit('value-update', e, rnum, cnum);
    }

    function clearValue() {
      emit('value-update', []);
    }

    return {
      deleteColumn,
      deleteRow,
      addColumn,
      addRow,
      updateValue,
      clearValue,
    };
  },
});
export default Component;
